import { useState } from 'react';
import { useRouter } from 'next/navigation';
import Link from 'next/link';
import { MainMenu, MainMenuStory, MainMenuBaileys } from './Menu.styles';
import Modal from '@components/Modal';
import Thestorymodal from '@components/ModalStory';
import Baileysmodal from '@components/ModalBaileys';
import LadyBaileymodal from '@components/ModalLadyBailey';

type MenuProps = {
  onOpen?: () => void;
  onStoryHidden?: () => void;
  showBaileysMenu?: boolean;
  showCopywritingMenu?: boolean;
  showBaileys?: boolean;
  showTheStory?: boolean;
  mBtt?: string;
  subscribeText?: string;
};

const Menu = ({
  onOpen,
  showBaileysMenu,
  showBaileys,
  showTheStory,
  mBtt,
  subscribeText,
  showCopywritingMenu
}: MenuProps) => {
  const [isModalopen, setIsmodalopen] = useState(false);
  const [isModalStory, setIsmodalStory] = useState(false);
  const [isModalBaileys, setIsmodalBaileys] = useState(false);
  const [isModalLadyBailey, setIsmodalLadyBailey] = useState(false);
  const [isAbout, setIsabout] = useState(false);
  const [isOpen, setIsopen] = useState(false);
  return (
    <>
      {showBaileysMenu && (
        <MainMenu style={{ marginBottom: mBtt }}>
          <li>
            <Link href="/">Martin's Home</Link>
          </li>
          <li>
            <Link href="/Breaking">
              <b>Breaking Live</b>
            </Link>
          </li>
          <li>
            <Link href="/Couture">All Couture</Link>
          </li>
          <li>
            <Link href="/ads">Fall/Winter 25-26</Link>
          </li>
          <li>
            <Link href="http://fass-hion.jorgedd.com/Story/">
              FASS-HION Magazine
            </Link>
          </li>
          <li className="about">
            <span onClick={() => setIsabout(true)}>About</span>
          </li>
          <li className="about">
            <span onClick={() => setIsopen(true)}>Contact Us</span>
          </li>
          <li>
            <Link href="/collection/black_white/collection_black_white/">Collection</Link>
          </li>
          <li>
            <Link href="https://medium.com/@martinswriters" target="_blank">
              Blog
            </Link>
          </li>
        </MainMenu>
      )}

      {/* {showCopywritingMenu && (
        <MainMenu style={{ marginBottom: mBtt }}>
          <li>
            <Link href="/">The House</Link>
          </li>
          <li>
            <Link href="/stories/">Stories</Link>
          </li>
          <li>
            <Link href="/coaching/program/">Coaching Program</Link>
          </li>
          <li>
            <Link href="/collection/thmartins/">CEO Signature</Link>
          </li>
          <li>
            <Link href="/SignatureBags/">Signature Series</Link>
          </li>
          <li>
            <Link href="/victory/">Victory Branding</Link>
          </li>
          <li className="about">
            <span onClick={() => setIsabout(true)}>About</span>
          </li>
          <li className="about">
            <span onClick={() => setIsopen(true)}>Contact Us</span>
          </li>
        </MainMenu>
      )} */}


      {showCopywritingMenu && (
        <MainMenu style={{ marginBottom: mBtt }}>
          <li>
            <Link href="/">The House Club</Link>
          </li>
          <li>
            <Link href="/stories/">Stories</Link>
          </li>
          <li>
            <Link href="/club/">The Club</Link>
          </li>
          <li>
            <Link href="/Membership/">Membership</Link>
          </li>
          <li>
            <Link href="/Events/">Events & Galas</Link>
          </li>
          <li className="about">
            <span onClick={() => setIsopen(true)}>Contacts</span>
          </li>
          {/* <li>
            <Link href="/">Login</Link>
          </li> */}
        {/* 
          <li>
            <Link href="/victory/">Victory Branding</Link>
          </li> */}
        </MainMenu>
      )}

      {showTheStory && (
        <MainMenuStory style={{ marginBottom: mBtt }}>
          <li>
            <Link
              href="http://thestory.jorgedd.com"
              style={{ textDecoration: 'underline', color: 'rgba(0,0,0, 0.5)' }}
              target="_blank"
              rel="noreferrer"
            >
              <b>Go to our Magazine</b>
            </Link>
          </li>
        </MainMenuStory>
      )}
      {isModalopen && (
        <Modal
          newsModal
          addStyle="1px solid #eee"
          backModal="rgba(250, 250, 250, 0.97)"
          subscribeText={subscribeText}
          onClose={() => setIsmodalopen(false)}
        />
      )}
      {isModalStory && (
        <Thestorymodal isClosed={() => setIsmodalStory(false)} />
      )}
      {isModalBaileys && (
        <Baileysmodal isClosed={() => setIsmodalBaileys(false)} />
      )}
      {isModalLadyBailey && (
        <LadyBaileymodal isClosed={() => setIsmodalLadyBailey(false)} />
      )}
      {isAbout && <Modal onClose={() => setIsabout(false)} aboutModal />}
      {isOpen && (
        <Modal
          onClose={() => setIsopen(false)}
          contactModal
          // logo={logo}
          // email={email}
          whatAppmsg="Hi George Martins,%0a%0aI would like to talk about my project with you. Could we have a chat about it, please?%0aThank you!%0a%0aMy name:%0a%0aMy Email:%0a%0aMy number:"
          whatAppLink="I'm looking forward to speak about your project. Click here to connect with me!"
        />
      )}
    </>
  );
};

export default Menu;
